import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import React from "react";
import { Hourglass } from "lucide-react";

const AverageWaitingTimeWidget: React.FC<{ data: { value: number; comparisonPercentage?: number }; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <div className="text-[14x] font-[500] text-primary dark:text-white truncate">Average Waiting Time</div>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <Hourglass className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The average amount of time that the callers had to wait for an agent to answer within a given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div>
      <WidgetMetricDisplay
        value={data.value}
        comparisonPercentage={data.comparisonPercentage}
        loading={loading}
        format="datetime"
        invertColors={true}
      />
    </div>
  </div>
);

export default AverageWaitingTimeWidget; 